import Lenis from "lenis";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMG = {
  logo: "https://customer-assets-lqy194kg.emergentagent.net/job_35278c6f-ca19-42f2-86da-5fd292604711/artifacts/juirg4mh_Screenshot_20260925_005136_Messages.jpg",
  heroTable: "https://customer-assets-lqy194kg.emergentagent.net/job_35278c6f-ca19-42f2-86da-5fd292604711/artifacts/yaq70ubd_IMG_20260925_015314.webp",
  swatches: "https://customer-assets-lqy194kg.emergentagent.net/job_35278c6f-ca19-42f2-86da-5fd292604711/artifacts/581fdgu0_IMG_20260925_015254.png",
  branding: "https://customer-assets-lqy194kg.emergentagent.net/job_35278c6f-ca19-42f2-86da-5fd292604711/artifacts/z0wiza20_IMG_20260925_015258.webp",
  flame: "https://customer-assets-lqy194kg.emergentagent.net/job_35278c6f-ca19-42f2-86da-5fd292604711/artifacts/o12m24uz_IMG_20260925_015303.webp",
  twilight: "https://images.unsplash.com/photo-1782022536403-f687337708c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBwYXRpbyUyMGR1c2slMjBmaXJlcGxhY2UlMjBvdXRkb29yfGVufDB8fHx8MTc5MDMxNzI2NXww&ixlib=rb-4.1.0&q=85",
  cellar: "https://images.unsplash.com/photo-1608232385022-8ba61bec6c59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHx3aGlza2V5JTIwYmFycmVsJTIwY2VsbGFyJTIwb2FrJTIwcnVzdGljfGVufDB8fHx8MTc5MDMxNzI3N3ww&ixlib=rb-4.1.0&q=85",
  vineyard: "https://images.unsplash.com/photo-1602860739945-9a61573cd62d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB2aW5leWFyZCUyMGVzdGF0ZSUyMHBhdGlvJTIwZHVza3xlbnwwfHx8fDE3OTAzMTcyNzN8MA&ixlib=rb-4.1.0&q=85",
  estate: "https://images.unsplash.com/photo-1674811025588-208f360d89cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB2aW5leWFyZCUyMGVzdGF0ZSUyMHBhdGlvJTIwZHVza3xlbnwwfHx8fDE3OTAzMTcyNzN8MA&ixlib=rb-4.1.0&q=85",
};

export const CONTACT = {
  email: "info@cozyember.design",
  emailHref: "mailto:info@cozyember.design",
  region: "Ontario, Canada",
};

export const BASE_PRICE = 3850;

export const BARRELS = [
  { id: "bourbon-oak", name: "Kentucky Bourbon Oak", price: 0, desc: "Charred American white oak, deep amber grain, distillery provenance." },
  { id: "wine-cask", name: "French Wine Cask", price: 150, desc: "Wine-stained oak with a warmth and history only a vineyard can give." },
  { id: "espresso-reserve", name: "Espresso Reserve Oak", price: 200, desc: "Distressed, dark-roasted finish for contemporary architectural spaces." },
];

export const STONES = [
  { id: "black-granite", name: "Black Granite", price: 0, desc: "Absolute black, flamed texture — ember light dances across its face.", swatch: "radial-gradient(circle at 32% 28%, #3a3a40, #131316 65%, #08080a)" },
  { id: "limestone", name: "Limestone", price: 200, desc: "Soft alabaster warmth, honed smooth — quiet, architectural, timeless.", swatch: "radial-gradient(circle at 32% 28%, #e6dcc6, #c9bda3 65%, #a89a80)" },
  { id: "dove-gray", name: "Dove Gray", price: 150, desc: "Cool misted concrete-grey, precision water-jet cut edges.", swatch: "radial-gradient(circle at 32% 28%, #d4d7d8, #a8abad 65%, #84878a)" },
  { id: "slate-gray", name: "Slate Gray", price: 250, desc: "Storm-grey with fine mineral veining and a velvet matte hand.", swatch: "radial-gradient(circle at 32% 28%, #9aa0a4, #6b7176 65%, #4c5155)" },
  { id: "hermosa", name: "Hermosa", price: 400, desc: "Rare movement of sand, smoke and bronze — no two tops alike.", swatch: "radial-gradient(circle at 30% 26%, #c4b096, #96826a 55%, #6b5a46)" },
  { id: "natural-slate", name: "Natural Slate", price: 300, desc: "Deep cleft charcoal slate, split-face texture, unmistakably organic.", swatch: "radial-gradient(circle at 32% 28%, #5b646c, #383f46 65%, #22272c)" },
];

export const BURNER_MEDIA = [
  { id: "lava-rock", name: "Volcanic Black Lava", price: 0, desc: "Tumbled lava stone — the classic ember-bed glow." },
  { id: "fireglass", name: "Reflective Amber Fireglass", price: 150, desc: "Tempered glass that multiplies the flame into liquid gold." },
  { id: "river-stone", name: "Ceramic River Stones", price: 100, desc: "Sculpted stones for a soft, organic flame pattern." },
];

export const ENGRAVING = [
  { id: "none", name: "No Engraving", price: 0, desc: "The barrel speaks for itself." },
  { id: "monogram", name: "Family Monogram", price: 350, desc: "A family name, cottage name or estate mark, hand-burned into the staves." },
  { id: "crest", name: "Custom Crest / Corporate Logo", price: 500, desc: "Your full emblem, laser-etched and hand-finished — unmistakably yours." },
];

export const SHAPES = [
  { id: "round", name: "Round", price: 0 },
  { id: "square", name: "Square", price: 100 },
];

export const WIND_GUARD_PRICE = 250;

export const INPUT_CLS =
  "w-full rounded-lg border border-stone-800 bg-stone-950/60 px-4 py-3 text-sm text-stone-100 placeholder-stone-600 outline-none transition-colors duration-200 focus:border-amber-500/60 focus:ring-1 focus:ring-amber-500/40";

export const fmtCAD = (n) => `$${n.toLocaleString("en-CA")}`;

let lenisInstance = null;

export const initLenis = () => {
  lenisInstance = new Lenis({ duration: 1.15, smoothWheel: true });
  const raf = (time) => {
    lenisInstance.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
  return lenisInstance;
};

export const scrollToHash = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (lenisInstance) lenisInstance.scrollTo(el, { offset: -90, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const scrollTop = () => {
  if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
};
